import React from "react";

const PageNotFound = () => {
  return (
    <div className="container">
      <div className="row mt-5 d-flex justify-content-center">
        <div className="col-lg-6 mt-5 shadow rounded p-5 text-center text-dark display-6 bg-white">
          Page Not Found.
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
